// MODALS MIXIN
export const ModalsMixin = {
   data() {
      return {
         modals: {
            contactForm: {
               show: false,
               success: false,
               errors: [],
               fields: {
                  company: '',
                  deliveryAddress1: '',
                  deliveryAddress2: '',
                  deliveryCity: '',
                  deliveryCountry: '',
                  deliveryDate: null,
                  deliveryPostalCode: '',
                  email: '',
                  errorsReport: [],
                  firstName: '',
                  funnelScenario: window.mymy.request.scenario,
                  guests: null,
                  lastName: '',
                  message: '',
                  occasion: '',
                  orderNumber: '',
                  phoneNumber: '',
                  scenario: 'funnel',
                  topic: 'funnelErrors',
               },
            },
            courseExtras: {show: false},

            // For package menus only. This is data used for the modal that appears when the
            // customer deselects a dish from a previous course and needs to go back to fulfill
            // the minimum required dishes.
            courseWarning: {
               show: false,
               variantId: null,
               requiredMinimum: 0,
               title: '',
            },

            errors: {show: false, messages: []},
            faq: {show: false},
            loading: {show: false},
            menuItemDetails: {show: false},
            mobileFilters: {show: false},
            mobileSummary: {show: false},
         },
      }
   },
   methods: {
      /**
       * Cancel the modal that pops up when a customer clicked on "Remove" (trashcan icon) in
       * the summary to remove a package menu item and chose to keep the item instead of
       * removing it from their order.
       */
      cancelCourseWarning() {
         this.modals.courseWarning.variantId = null;
         this.modals.courseWarning.show = false;
      },

      /**
       * Close any modals that might be open.
       */
      closeAllModals(except = []) {
         for (const key in this.modals) {
            if (! except.includes(key)) {
               this.modals[key].show = false;
            }
         }
      },

      /**
       * Open the modal to display errors to the customer.
       *
       * @param errors {string|array}
       */
      showErrorModal(errors) {
         if (typeof errors === 'string') {
            errors = [errors];
         }
         this.modals.errors.messages = errors;
         this.closeAllModals();
         this.modals.errors.show = true;
      },

      /**
       * Open or close the summary modal on mobile.
       */
      toggleMobileSummary() {
         this.modals.mobileSummary.show = !this.modals.mobileSummary.show;
      },

      /**
       * For package menus when the customer has selected the required amount of dishes for a course
       * section, show the modal that asks them if they want to add extra dishes.
       *
       * @param section {<MenuSection>}
       */
      showExtraDishesModal(section) {
         // only applies to package menus
         if (this.menu.isALaCarte) {
            return;
         }

         // there's no fulfillment needed for line item steps like "Drinks" or "Accessories", only
         // courses
         if (! section.isForCourseDishes) {
            return;
         }

         // don't show the modal for a section we're not currently viewing
         if (section.index !== this.sectionIndex) {
            return;
         }

         // show the modal informing the customer they can add extra dishes from this course
         this.modals.courseExtras.show = true;
      },

      /**
       * When a customer clicks on a menu item, open a modal showing more details about it.
       *
       * @param variant {string|number|{id: Number, slug: String}}
       */
      showMenuItemDetails(variant) {
         const MenuItemControls = this.getMenuItemComponent(variant);
         if (! MenuItemControls) {
            return;
         }

         this.closeAllModals();
         this.$store.commit('setFocusedMenuItem', MenuItemControls);
         this.modals.menuItemDetails.show = true;

         // fire off a GTM event
         try {
            this.gtmViewItemDetails(MenuItemControls);
         }
         catch (e) {
            if(window.Sentry) {
               Sentry.captureException(e);
            }
            console.error(e);
         }
      },

      /**
       * When the customer submits the "Errors" contact form
       *
       * @return {Promise<void>}
       */
      async onSubmitErrorsContactForm() {
         this.modals.loading.show = true;

         // check the honey pot for values
         if (this.$refs.title.value !== '') {
            this.modals.contactForm.success = true;
            return;
         }

         this.modals.contactForm.fields.orderNumber = this.$store.state.cart.shortNumber;
         this.modals.contactForm.fields.guests = this.$store.state.cart.numberOfPeople;

         // send the data to our controller (and include any extra data from the URL like UTM
         // params for marketing and tracking)
         const response = await this.makePostRequest(
            'mymy/forms/submit-contact-form' + window.location.search,
            {
               fields: this.modals.contactForm.fields,
               title: this.$refs.title.value
            }
         );

         if (response?.data?.success) {
            this.modals.contactForm.success = true;
         }
         else if (response?.data?.errors) {
            this.modals.contactForm.success = false;
            this.modals.contactForm.errors = this.getYiiErrors(response.data.errors);
         }
         else {
            this.modals.loading.show = false;
            if(window.Sentry) {
               Sentry.captureMessage("Response not handled correctly")
            }
         }
      },
   },
};